module.exports = __webpack_public_path__ + "img/3edaa8ec241b4d2697bfcff829c963f2.f15aebc2.png";